import { RouterView } from 'vue-router';

export const programRoutes = {
  path: 'program/:programId',
  component: () => import('layouts/ProgramLayout.vue'),
  name: 'showProgram',
  redirect: { name: 'showProgramDashboard' },
  children: [
    {
      path: '',
      redirect: { name: 'showProgramDashboard' },
    },
    {
      name: 'showProgramDashboard',
      path: 'dashboard',
      component: () => import('pages/program/DashboardPage.vue'),
    },
    {
      name: 'showProgramGradeSubmitted',
      path: 'grade_submitted',
      component: RouterView,
      redirect: { name: 'showProgramGradeSubmittedList' },
      children: [
        {
          path: 'courses',
          name: 'showProgramGradeSubmittedList',
          redirect: { name: 'showProgramGradeSubmittedListCommonModules' },
          component: () => import('pages/program/GradeSubmittedNav.vue'),
          children: [
            {
              name: 'showProgramGradeSubmittedListCommonModules',
              path: 'modules',
              component: () =>
                import('pages/program/GradeSubmittedModules.vue'),
            },
          ],
        },

        {
          path: 'show/:courseInstanceId',
          name: 'showProgramGradeSubmittedShow',
          component: () => import('pages/program/GradeSubmittedCourseShow.vue'),
          children: [
            {
              name: 'showProgramGradeSubmittedShowEnrollment',
              path: 'enrollment/:enrollmentId',
              component: () =>
                import('pages/program/GradeSubmittedEnrollment.vue'),
            },
            {
              name: 'showProgramGradeSubmittedShowReport',
              path: 'report',
              component: () => import('pages/program/GradeSubmittedReport.vue'),
            },
          ],
        },
      ],
    },

    {
      name: 'showProgramSRTI',
      path: 'srti',
      redirect: { name: 'showProgramStudentResponses' },
      component: RouterView,
      children: [
        {
          name: 'showProgramStudentResponses',
          path: '',
          component: () => import('pages/program/StudentResponses.vue'),
        },
        {
          name: 'showProgramStudentResponsesCourse',
          path: ':courseInstanceId',
          component: () => import('pages/program/StudentResponseCourse.vue'),
        },
      ],
    },
    {
      name: 'showProgramModules',
      path: 'module',
      component: () => import('pages/program/ModulesPage.vue'),
      redirect: { name: 'showProgramModulesList' },
      children: [
        {
          name: 'showProgramModulesList',
          path: '',
          component: () => import('pages/program/ProgramModulesPage.vue'),
        },
        {
          name: 'showProgramTranscript',
          path: 'transcript',
          component: () => import('pages/program/ProgramTranscriptPage.vue'),
        },
        {
          name: 'showProgramTranscriptPdfPreview',
          path: 'transcript-pdf',
          component: () =>
            import('pages/program/ProgramTranscriptPdfPreviewPage.vue'),
        },
      ],
    },
    // {
    //   name: 'showProgramStudentCourse',
    //   path: 'student_course',
    //   component: () => import('pages/program/StudentCourse.vue'),
    // },
    {
      name: 'showProgramCourse',
      path: 'courses',
      component: () => import('pages/program/CoursesPage.vue'),
      redirect: { name: 'ProgramCourseList' },
      children: [
        {
          name: 'ProgramCourseList',
          path: '',
          component: () => import('pages/program/CourseListPage.vue'),
        },
        {
          name: 'ProgramCourseSchedule',
          path: 'schedule',
          component: () => import('pages/program/CourseSchedulePage.vue'),
        },
      ],
    },
    {
      name: 'showProgramStudents',
      path: 'student',
      redirect: { name: 'showProgramStudentsList' },
      component: () => import('pages/program/StudentPage.vue'),
      children: [
        {
          name: 'showProgramStudentsList',
          path: '',
          component: () => import('pages/program/StudentList.vue'),
        },
        {
          name: 'ProgramActiveStudentsList',
          path: 'active',
          component: () => import('pages/program/StudentActiveList.vue'),
        },
        {
          name: 'showProgramStudentDetails',
          path: ':userId',
          component: () => import('pages/program/StudentDetails.vue'),
          children: [
            {
              name: 'showProgramStudentSchedule',
              path: 'schedule',
              component: () => import('pages/program/StudentSchedule.vue'),
            },
            {
              name: 'showProgramStudentEnrollments',
              path: 'enrollments',
              component: () => import('pages/program/StudentEnrollments.vue'),
            },
            {
              name: 'showProgramStudentUserPrograms',
              path: 'user_programs',
              component: () => import('pages/program/StudentUserPrograms.vue'),
              children: [
                {
                  path: ':userProgramId',
                  name: 'showProgramStudentUserProgramDetails',
                  component: () =>
                    import('pages/program/StudentUserProgramDetails.vue'),
                },
              ],
            },

            {
              name: 'showProgramStudentProgram',
              path: 'study_plan/:userProgramId',
              component: () => import('pages/program/StudentProgram.vue'),
            },
          ],
        },
      ],
    },
    {
      name: 'showProgramLecturers',
      path: 'lecturer',
      component: () => import('pages/program/LecturerList.vue'),
    },
    {
      name: 'showProgramThesis',
      path: 'thesis',
      component: () => import('pages/program/ThesisList.vue'),
    },
    {
      name: 'showProgramThesisDetails',
      path: 'thesis/:thesisId',
      component: () => import('pages/program/ThesisDetails.vue'),
    },
  ],
};
